import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "risk" }
const _hoisted_2 = { class: "record-info" }
const _hoisted_3 = { class: "right" }
const _hoisted_4 = { class: "audio" }
const _hoisted_5 = { class: "cantonese-audio" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "timer" }
const _hoisted_8 = { class: "cantonese-audio" }
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "timer" }
const _hoisted_11 = { class: "agree" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_count_down = _resolveComponent("van-count-down")!
  const _component_van_checkbox = _resolveComponent("van-checkbox")!
  const _component_van_field = _resolveComponent("van-field")!
  const _component_layout = _resolveComponent("layout")!

  return (_openBlock(), _createBlock(_component_layout, {
    onHandleNext: _ctx.handleNext,
    current: 2,
    isDisabled: _ctx.isDisabled,
    prePathName: "tax-info"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _cache[12] || (_cache[12] = _createElementVNode("div", { class: "title" }, "风险披露", -1)),
        _createElementVNode("div", _hoisted_2, [
          _cache[9] || (_cache[9] = _createElementVNode("div", { class: "avatar" }, [
            _createElementVNode("i")
          ], -1)),
          _createElementVNode("div", _hoisted_3, [
            _cache[7] || (_cache[7] = _createElementVNode("div", { class: "name" }, "持牌代表：Yuan Jingna", -1)),
            _cache[8] || (_cache[8] = _createElementVNode("div", { class: "number" }, "牌照号：AVR360", -1)),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("audio", {
                  ref: "cantoneseEl",
                  src: _ctx.cantonese.url
                }, null, 8, _hoisted_6),
                _createElementVNode("i", {
                  class: _normalizeClass(`iconfont ${!_ctx.cantonese.status ? 'icon-bofang' : 'icon-ai05'}`),
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.changeCantonesePlay && _ctx.changeCantonesePlay(...args)))
                }, null, 2),
                _cache[5] || (_cache[5] = _createElementVNode("p", null, "粤语", -1)),
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(_component_van_count_down, {
                    ref: "cantoneseCountEl",
                    class: "timer-count",
                    "auto-start": _ctx.cantoneseAutoStart,
                    format: "mm:ss",
                    onFinish: _ctx.finish,
                    time: _ctx.cantoneseTime
                  }, null, 8, ["auto-start", "onFinish", "time"])
                ])
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("audio", {
                  ref: "mandarinEl",
                  src: _ctx.mandarin.url
                }, null, 8, _hoisted_9),
                _createElementVNode("i", {
                  class: _normalizeClass(`iconfont ${!_ctx.mandarin.status ? 'icon-bofang' : 'icon-ai05'}`),
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.changeMandarinPlay && _ctx.changeMandarinPlay(...args)))
                }, null, 2),
                _cache[6] || (_cache[6] = _createElementVNode("p", null, "普通话", -1)),
                _createElementVNode("div", _hoisted_10, [
                  _createVNode(_component_van_count_down, {
                    ref: "mandarinCountEl",
                    class: "timer-count",
                    "auto-start": _ctx.mandarinAutoStart,
                    format: "mm:ss",
                    onFinish: _ctx.finish,
                    time: _ctx.mandarinTime
                  }, null, 8, ["auto-start", "onFinish", "time"])
                ])
              ])
            ])
          ])
        ]),
        _cache[13] || (_cache[13] = _createElementVNode("div", { class: "introduce" }, [
          _createElementVNode("div", null, [
            _createElementVNode("p", null, " 尊敬的客户，您好，我是一位金马证券有限公司的持牌代表Yuan Jingna，我的中央编号是AVR360。 在开通账户前，请您仔细阅读金马证券的客户协议书和相关投资产品的风险披露声明。 在作出任何投资决定前，您需了解自身的投资经验及目的、风险承受能力、财政状况等，从而审慎考虑该投资产品是否适合您投资。 以下为风险披露声明的节录： "),
            _createElementVNode("div", null, "1. 证券交易的风险"),
            _createElementVNode("p", null, " 证券价格有时可能会非常波动。 证券价格可升可跌，甚至变成毫无价值。 买卖证券未必一定能赚取利润，反而可能会招致损失。 "),
            _createElementVNode("div", null, "2. 买卖创业板股份的风险"),
            _createElementVNode("p", null, " 创业板股份涉及很高的投资风险。 尤其是该等公司可在无需具备盈利业绩及无需预测未来盈利的情况下在创业板上市。 创业板股份可能会非常波动及流通性很低。 "),
            _createElementVNode("div", null, "3.透过沪港通/深港通买卖证券的特定风险"),
            _createElementVNode("p", null, "包括"),
            _createElementVNode("p", null, "i.每日额度限制，"),
            _createElementVNode("p", null, "ii.只能买卖合资格沪深股票"),
            _createElementVNode("p", null, "iii.沽出限制"),
            _createElementVNode("p", null, "iv.交易日及交易时间差异"),
            _createElementVNode("p", null, "v.内地法规、外资持股比例限制及披露责任"),
            _createElementVNode("p", null, "vi.股票交收及资金结算安排"),
            _createElementVNode("div", null, "4. 买卖环球证券的风险"),
            _createElementVNode("p", null, " 环球证券的价值或收益可能较为波动及可能因货币汇率、当地税务惯例、法例或政治事件而遭受负面影响。 您有可能较难变卖环球证券。 当地法例也可能影响环球证券的可转让性。 而且，有些环球证券交易市场股票的跌幅或升幅超过特定百分比时，有关市场可能会暂停有关股票的交易、对有关股票实施熔断机制或市场波动调节机制等。 "),
            _createElementVNode("div", null, "5. 货币兑换风险"),
            _createElementVNode("p", null, " 货币兑换需承受因汇率波动而产生的风险。倘若您货币兑换的汇率较当初的汇率为差，您可能会因而蒙受本金损失。 "),
            _createElementVNode("div", null, "6. 在香港以外地方收取或持有的客户资产的风险"),
            _createElementVNode("p", null, " 金马证券在香港以外地方收取或持有您的资产，是受到有关海外司法管辖区的适用法律及规例所监管的，请注意，不受投资者赔偿基金保障。 这些香港以外地方的法律及规例与《证券及期货条例》（香港法例第571 章）可能有所不同。 "),
            _createElementVNode("div", null, "7. 电子交易的风险"),
            _createElementVNode("p", null, " 透过电子交易服务进行买卖，潜在风险包括有关系统硬件或软件可能会失灵、网络不稳定、未能预计的网络拥挤等。 "),
            _createElementVNode("p", null, " 通过电子交易服务向您提供的市场数据及其他信息，可能是金马证券从第三方或服务供货商获得的。虽然金马证券相信这些数据和信息是可靠的，但金马证券、该等第三方或服务供货商都不会保证这些数据和信息的准确性、完整性和实时性。 "),
            _createElementVNode("div", null, "8. 提供代存邮件或将邮件转交第三方的授权书的风险"),
            _createElementVNode("p", null, " 假如您向金马证券提供授权书，允许第三方代存邮件或将邮件转交予第三方，那么您便须尽速亲身收取所有关于您账户的成交单据及结单，并加以详细阅读，以确保可及时侦察到任何差异或错误。 "),
            _createElementVNode("div", null, "9. 在香港联合交易所有限公司买卖纳斯达克－美国证券交易所证券的风险"),
            _createElementVNode("p", null, " 按照纳斯达克－美国证券交易所试验计划挂牌买卖的证券是为熟悉投资技巧的投资者而设的。您在买卖该项试验计划的证券之前，应先熟悉该项试验计划。 您应知悉，按照该项试验计划挂牌买卖的证券并非以香港联合交易所有限公司的主板或创业板作第一或第二上市的证券类别加以监管。 "),
            _createElementVNode("div", null, "以下是泛及开立保证金账户的风险"),
            _createElementVNode("div", null, "保证金买卖的风险"),
            _createElementVNode("p", null, " 借存放抵押品而为交易取得融资的亏损风险可能极大。蒙受的亏蚀可能会超过您存放于金马证券作为抵押品的现金及任何其他资产。 您可能会在短时间内被要求存入额外的保证金款项或缴付利息。假如您未能在指定的时间内支付所需的保证金款项或利息，您的抵押品可能会在未经您的同意下被出售。在市场波动下，金马证券未必能实时联络您或提供足够时间予您存款，而您的持仓将有可能因此被强制平仓。 此外，您将要为您的账户内因此而出现的任何短欠金额及需缴付的利息负责。 "),
            _createElementVNode("p", null, "最后您同意客户协议书内的客户款项常设授权、客户证券常设授权或其他的常设授权"),
            _createElementVNode("p", null, "以上常设授权有效期为十二个月，自本协议书生效之日起计有效。"),
            _createElementVNode("p", null, " 您明白金马证券若在客户款项常设授权及客户证券常设授权的有效期届满 14 日之前，向您发出书面通知，提醒您有关的常设授权即将届满，而您没有在届满前反对该等常设授权续期，您的客户款项常设授权及客户证券常设授权将按照相同条件及细则自动续期12个月。 "),
            _createElementVNode("div", null, "提供证券抵押品等再质押的授权书的风险"),
            _createElementVNode("p", null, " 证券借贷协议书使用您的证券或证券抵押品、将您的证券抵押品再质押以取得财务通融，或将您的证券抵押品存放为用以履行及清偿其交收责任及债务的抵押品，存在一定风险。 假如您的证券或证券抵押品是由金马证券在香港收取或持有，则上述安排仅限于您已就此给予书面同意的情况下方行有效。此外，除非您是专业投资者，您的授权书必须指明有效期，而该段有效期不得超过12个月。若您是专业投资者，则有关限制并不适用。 "),
            _createElementVNode("p", null, " 此外，假如金马证券在有关授权的期限届满前最少14日向您发出有关授权将被视为已续期的提示，而您对于有关授权的期限届满前以书面方式将该授权延续不表示反对，则您的授权将按照相同条款及细则自动续期12个月。 ")
          ])
        ], -1)),
        _createElementVNode("div", _hoisted_11, [
          _createVNode(_component_van_field, {
            name: "agree",
            rules: [{ required: true, message: '请同意以上条款' }]
          }, {
            input: _withCtx(() => [
              _createVNode(_component_van_checkbox, {
                modelValue: _ctx.riskChecked,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.riskChecked) = $event)),
                shape: "square"
              }, {
                icon: _withCtx(() => [
                  _createElementVNode("i", {
                    class: _normalizeClass(
                    `iconfont ${_ctx.riskChecked ? 'icon-duoxuanxuanzhong' : 'icon-duoxuanweixuanzhong'}`
                  )
                  }, null, 2)
                ]),
                default: _withCtx(() => [
                  _cache[10] || (_cache[10] = _createTextVNode(" 本人完全细阅、同意、确认、接受、明白及愿意遵守 ")),
                  _createElementVNode("span", {
                    onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.toClient && _ctx.toClient(...args)), ["stop"]))
                  }, "《客户声明》"),
                  _cache[11] || (_cache[11] = _createTextVNode(" 及以上")),
                  _createElementVNode("span", {
                    onClick: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.toRisk && _ctx.toRisk(...args)), ["stop"]))
                  }, "《风险披露声明》")
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _: 1
  }, 8, ["onHandleNext", "isDisabled"]))
}